"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Svg_1 = __importDefault(require("./Svg"));
var hooks_1 = require("../hooks");
var Close = function (_a) {
    var color = _a.color, _b = _a.size, size = _b === void 0 ? '24px' : _b, rest = __rest(_a, ["color", "size"]);
    var theme = hooks_1.useTheme();
    var fillColor = color || theme.colors.black;
    return (react_1["default"].createElement(Svg_1["default"], __assign({ x: "0px", y: "0px", viewBox: "0 0 512.001 512.001", enableBackground: "new 0 0 1000 1000", xmlSpace: "preserve", width: size, height: size, version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", color: fillColor }, rest),
        react_1["default"].createElement("title", null, "Close"),
        react_1["default"].createElement("g", null,
            react_1["default"].createElement("g", null,
                react_1["default"].createElement("path", { d: "M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717\n\t\t\tL34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859\n\t\t\tc-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287\n\t\t\tl221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285\n\t\t\tL284.286,256.002z" })))));
};
exports["default"] = Close;
//# sourceMappingURL=Close.js.map